(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["freonwell-bulk-discount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('freonwell-bulk-discount')) {
    customElements.define(
      'freonwell-bulk-discount',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.addEventListener('click', this.handleClick.bind(this));
        }

        async handleClick(event) {
          const button = event.target.closest('button[data-quantity]');
          if (!button || button.disabled) return;

          const section = this.closest('.shopify-section');
          const productForm = section ? section.querySelector('form[action*="/cart/add"]') : null;
          const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
          const variantId = Number(variantInput ? variantInput.value : this.dataset.variantId);
          const quantity = Number(button.dataset.quantity);
          const status = this.querySelector('.fw-bulk-discount__status');
          const buttons = this.querySelectorAll('button[data-quantity]');
          const originalText = button.textContent;
          const rootUrl = this.dataset.rootUrl || '/';

          if (!variantId || !quantity) {
            status.textContent = 'Please select an available product option.';
            return;
          }

          buttons.forEach((item) => {
            item.disabled = true;
          });
          button.textContent = 'Adding…';
          status.textContent = '';

          try {
            const response = await fetch(`${rootUrl}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity
                  }
                ]
              })
            });

            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || 'Unable to add these items to the cart.');
            }

            window.location.href = `${rootUrl}cart`;
          } catch (error) {
            status.textContent = error.message;
            button.textContent = originalText;
            buttons.forEach((item) => {
              item.disabled = false;
            });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["freonwell-mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const navigationSelector = '[data-fw-mobile-nav]';
    const spacerSelector = '[data-fw-mobile-nav-spacer]';

    const matchingElements = (scope, selector) => {
      const elements = Array.from(scope.querySelectorAll(selector));

      if (scope instanceof Element && scope.matches(selector)) {
        elements.unshift(scope);
      }

      return elements;
    };

    const mountNavigation = (scope = document) => {
      matchingElements(scope, navigationSelector).forEach((navigation) => {
        const sectionId = navigation.dataset.sectionId;
        const mountedNavigation = document.body.querySelector(`:scope > ${navigationSelector}`);
        const spacer = document.querySelector(
          `${spacerSelector}[data-section-id="${CSS.escape(sectionId)}"]`
        );

        if (mountedNavigation && mountedNavigation !== navigation) {
          navigation.remove();
          spacer?.remove();
          return;
        }

        if (spacer && spacer.parentElement !== document.body) {
          document.body.append(spacer);
        }

        if (navigation.parentElement !== document.body) {
          document.body.append(navigation);
        }
      });
    };

    const removeNavigation = (sectionId) => {
      if (!sectionId) {
        return;
      }

      const escapedSectionId = CSS.escape(String(sectionId));
      document
        .querySelectorAll(
          `${navigationSelector}[data-section-id="${escapedSectionId}"], ${spacerSelector}[data-section-id="${escapedSectionId}"]`
        )
        .forEach((element) => element.remove());
    };

    const initialize = () => mountNavigation(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      mountNavigation(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      removeNavigation(event.detail?.sectionId);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["freonwell-shipping-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-zip-popup')) {
    customElements.define('delivery-zip-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        const zones=[[35000,36999,"AL",4,5],[85000,86599,"AZ",2,3],[71600,72999,"AR",4,5],[75500,75599,"AR",4,5],[90000,96199,"CA",2,3],[80000,81699,"CO",3,4],[6000,6999,"CT",4,5],[19700,19999,"DE",4,5],[20000,20599,"DC",4,5],[32000,34999,"FL",4,5],[30000,31999,"GA",4,5],[39800,39999,"GA",4,5],[83200,83899,"ID",3,4],[60000,62999,"IL",4,5],[46000,47999,"IN",4,5],[50000,52899,"IA",4,5],[66000,67999,"KS",4,5],[40000,42799,"KY",4,5],[70000,71499,"LA",4,5],[3900,4999,"ME",4,5],[20600,21999,"MD",4,5],[1000,2799,"MA",4,5],[5500,5599,"MA",4,5],[48000,49999,"MI",4,5],[55000,56799,"MN",4,5],[38600,39799,"MS",4,5],[63000,65899,"MO",4,5],[59000,59999,"MT",4,5],[68000,69399,"NE",4,5],[88900,89899,"NV",2,3],[3000,3999,"NH",4,5],[7000,8999,"NJ",4,5],[87000,88499,"NM",2,3],[500,599,"NY",4,5],[6300,6399,"NY",4,5],[10000,14999,"NY",4,5],[26900,28999,"NC",4,5],[58000,58899,"ND",4,5],[43000,45999,"OH",4,5],[73000,74999,"OK",3,4],[97000,97999,"OR",3,4],[15000,19699,"PA",4,5],[2800,2999,"RI",4,5],[29000,29999,"SC",4,5],[57000,57799,"SD",4,5],[37000,38599,"TN",4,5],[75000,79999,"TX",4,5],[88500,88599,"TX",4,5],[84000,84799,"UT",2,3],[5000,5999,"VT",4,5],[20100,20199,"VA",4,5],[22000,24699,"VA",4,5],[98000,99499,"WA",3,4],[24700,26899,"WV",4,5],[53000,54999,"WI",4,5],[82000,83199,"WY",3,4]];
        const denied=[[600,999],[9000,9899],[34000,34099],[96200,96999],[96700,96899],[99500,99999]];
        const dialog=this.querySelector('[data-dz-dialog]'),input=this.querySelector('[data-dz-input]'),result=this.querySelector('[data-dz-result]'),date=this.querySelector('[data-dz-date]'),detail=this.querySelector('[data-dz-detail]'),summary=this.querySelector('[data-dz-summary]'),location=this.querySelector('[data-dz-location]');
        const addBusinessDays=(value,days)=>{const output=new Date(value);let count=0;while(count<days){output.setDate(output.getDate()+1);if(output.getDay()!==0&&output.getDay()!==6)count+=1;}return output;};
        const pacificToday=()=>{const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());const values=Object.fromEntries(parts.map(part=>[part.type,part.value]));return new Date(Number(values.year),Number(values.month)-1,Number(values.day),12);};
        const formatDate=value=>new Intl.DateTimeFormat(document.documentElement.lang||'en-US',{month:'short',day:'numeric'}).format(value);
        const calculate=(raw,place='')=>{const zip=String(raw||'').replace(/\D/g,'').slice(0,5);input.value=zip;result.hidden=false;result.classList.remove('is-error');if(zip.length!==5){result.classList.add('is-error');date.textContent=this.dataset.validZip;detail.textContent=this.dataset.validDetail;return false;}const number=Number(zip);const blocked=denied.some(range=>number>=range[0]&&number<=range[1]);const zone=zones.find(range=>number>=range[0]&&number<=range[1]);if(blocked||!zone){result.classList.add('is-error');date.textContent=this.dataset.unavailable;detail.textContent=this.dataset.unavailableDetail;return false;}const shipDate=addBusinessDays(pacificToday(),1);const earliest=addBusinessDays(shipDate,zone[3]);const latest=addBusinessDays(shipDate,zone[4]);const deliveryWindow=`${formatDate(earliest)} – ${formatDate(latest)}`;date.textContent=`${this.dataset.estimated}: ${deliveryWindow}`;detail.textContent=`${this.dataset.ships} · FedEx Ground · ${zone[2]}`;summary.textContent=`${this.dataset.estimated} ${deliveryWindow}`;location.textContent=place||`${this.dataset.delivering} ${zip}, ${zone[2]}`;localStorage.setItem('deliveryZip',zip);return true;};
        this.querySelector('[data-dz-open]').addEventListener('click',()=>{dialog.showModal();setTimeout(()=>input.focus(),0);});
        this.querySelector('[data-dz-close]').addEventListener('click',()=>dialog.close());
        this.querySelector('[data-dz-form]').addEventListener('submit',event=>{event.preventDefault();calculate(input.value);});
        const saved=localStorage.getItem('deliveryZip');if(saved)calculate(saved);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
